import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';

export const cyberMonday2025: boolean = !IS_PAID_USER && !IS_BIZ_USER && promotionEndDate && getFeature('cyber-monday-2025');
